import { makeObservable, observable } from 'mobx';

import type { DefaultFilters } from '@lib/types';

let filterStore: FilterStore | null = null;

export class FilterStore {
  filters: DefaultFilters = {
    center: null,
    marker: null,
    address: '',
    zoom: null,
  };

  constructor() {
    makeObservable(this, {
      filters: observable.shallow,
    });
  }
}

// eslint-disable-next-line import/no-default-export
export default function getFilterStore(): FilterStore {
  if (filterStore === null) {
    filterStore = new FilterStore();
  }

  return filterStore;
}
